var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "1bce92c396dea42662395c14d0c6e7f0.png",
    width: 72,
    height: 72
});